import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, reactive } from 'vue';
import ZoomToggleContainer from './ZoomToggleContainer.vue';
import AutoOptimizedImage from '../auto-optimized-image/AutoOptimizedImage.vue';
import { ImageResizerOptions, ImageResizerModes } from '../util';
import { useCanHover } from '@/ui/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoOptimizedImageWithZoom',
  props: {
    baseUrl: null,
    altText: { default: '' },
    lossless: { type: Boolean },
    hasTransparency: { type: Boolean },
    imageResizerOptions: { default: undefined },
    imageResizerOptionsLegacy: { default: undefined },
    imageResizerMode: { default: undefined },
    lazyload: { type: Boolean, default: false },
    widthsRegular: null,
    widthsLegacyRegular: null,
    widthsZoomed: null,
    widthsLegacyZoomed: null,
    aspectRatio: { default: undefined },
    zoomLevel: { default: 2 },
    zoomedClass: { default: '' },
    zoomedImagePreload: { default: 'lazy' }
  },
  setup(__props: any) {

const props = __props as { baseUrl: string, altText: string, lossless: boolean, hasTransparency: boolean, imageResizerOptions: ImageResizerOptions, imageResizerOptionsLegacy: ImageResizerOptions, imageResizerMode: ImageResizerModes, lazyload: boolean, widthsRegular: number[], widthsLegacyRegular: number[], widthsZoomed: number[], widthsLegacyZoomed: number[], aspectRatio: number | undefined, zoomLevel: number, zoomedClass: string, zoomedImagePreload: 'none' | 'lazy' | 'eager' }



const { canHover } = useCanHover();
const rootComponent = ref<InstanceType<typeof ZoomToggleContainer> | undefined>();

const zoomedContainerSize = reactive({ w: 0, h: 0 });

const updateZoomedContainerSize = () => {
    if (!rootComponent.value || (!('$el' in rootComponent.value))) {
        return;
    }

    const rootEl = rootComponent.value.$el as HTMLElement;
    zoomedContainerSize.w = rootEl.clientWidth * props.zoomLevel;
    zoomedContainerSize.h = rootEl.clientHeight * props.zoomLevel;
};

const handleResize = () => {
    updateZoomedContainerSize();
};

const hasBeenZoomed = ref(false);
const handleZoomStateEnter = () => {
    hasBeenZoomed.value = true;
};

onMounted(() => {
    updateZoomedContainerSize();
});

return { __sfc: true,props, canHover, rootComponent, zoomedContainerSize, updateZoomedContainerSize, handleResize, hasBeenZoomed, handleZoomStateEnter, ZoomToggleContainer, AutoOptimizedImage }
}

})